export const LOCALSTORAGE_AUTH: string = 'authentication';
export const FORM_ERROR_SHOW: boolean = false;



// WEBPACK FOOTER //
// ./src/setup/configurations.ts